var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopNavBarBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3694_10801)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 16,
    r: 13,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1601 15.8572H12.0261L16.496 11.412C16.8188 11.0915 16.8207 10.57 16.5002 10.2472C16.1796 9.92442 15.6581 9.92258 15.3354 10.2431L9.44956 16.0836C9.41168 16.1216 9.37724 16.163 9.34666 16.2071V16.2318C9.32204 16.2693 9.30135 16.3094 9.28492 16.3511V16.38C9.28492 16.4211 9.25611 16.4623 9.24788 16.5034C9.24159 16.5581 9.24159 16.6134 9.24788 16.6681C9.24788 16.6681 9.24788 16.6969 9.24788 16.7092C9.24564 16.749 9.24564 16.7888 9.24788 16.8286C9.24788 16.8656 9.26846 16.8986 9.27669 16.9315C9.27902 16.9492 9.27902 16.9672 9.27669 16.985L9.33019 17.0838L9.35489 17.1249C9.38415 17.1665 9.41576 17.2063 9.44956 17.2443L15.3106 23.126C15.6354 23.4213 16.1346 23.4099 16.4455 23.1001C16.7564 22.7903 16.7696 22.291 16.4755 21.9653L12.0138 17.5036H25.1601C25.6147 17.5036 25.9833 17.1351 25.9833 16.6804C25.9833 16.2258 25.6147 15.8572 25.1601 15.8572Z",
    fill: "#494949"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3694_10801",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3694_10801"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3694_10801",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopNavBarBackArrow);
export default __webpack_public_path__ + "static/media/TopNavBarBackArrow.2bb695986e041591507a6be988a2f925.svg";
export { ForwardRef as ReactComponent };